module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step4-pict02-59b4fc2812bee0794e9c0f433f18e621.jpg";